import { MuiTableBody } from '../../../base-components';
import { ICell, ITableStructure } from '../../table.interfaces';
import { StyledTableRow } from '../Row/Row.styles';
import { allSkeletons } from '../../Cells/cells.consts';
import { CellType } from '../../table.consts';

interface TableSkeletonBodyProps {
    structure: ITableStructure;
}
const TableSkeletonBody = (props: TableSkeletonBodyProps) => {
    const { structure } = props;
    const { cells, rowSelection } = structure;
    const rows = [0, 1, 2];

    const renderSkeletonCell = (cell: ICell) => {
        const { id } = cell;
        const SkeletonCell = allSkeletons[cell.type];

        return <SkeletonCell key={id} />;
    };

    const renderSkeletonCells = () => {
        return cells.map((cell) => renderSkeletonCell(cell));
    };

    const renderSkeletonRows = (row: number) => {
        const CheckboxSkeleton = allSkeletons[CellType.Checkbox];
        return (
            <StyledTableRow key={row} isReadOnly={true} isRowClickable={false}>
                {rowSelection && <CheckboxSkeleton alignment={'left'} />}
                {renderSkeletonCells()}
            </StyledTableRow>
        );
    };

    return (
        <MuiTableBody>
            {rows?.map((row) => {
                return renderSkeletonRows(row);
            })}
        </MuiTableBody>
    );
};

export default TableSkeletonBody;
